if (!customElements.get('cart-sticky-bar')) {
  class CartStickyBar extends HTMLElement {
    constructor() {
      super();
      this.summaryTarget = null;
      this.observer = null;
      this.handleIntersection = this.handleIntersection.bind(this);
    }

    connectedCallback() {
      this.summaryTarget = document.querySelector('[data-cart-summary]');

      if (!this.summaryTarget) {
        this.toggleVisibility(false);
        return;
      }

      if ('IntersectionObserver' in window) {
        this.createObserver();
        return;
      }

      this.toggleVisibility(true);
    }

    disconnectedCallback() {
      this.destroyObserver();
    }

    createObserver() {
      this.destroyObserver();
      this.observer = new IntersectionObserver(this.handleIntersection, { threshold: 0 });
      this.observer.observe(this.summaryTarget);
    }

    handleIntersection(entries) {
      entries.forEach((entry) => this.toggleVisibility(!entry.isIntersecting));
    }

    toggleVisibility(isVisible) {
      this.classList.toggle('is-visible', Boolean(isVisible));
    }

    destroyObserver() {
      if (this.observer) {
        this.observer.disconnect();
        this.observer = null;
      }
    }
  }

  customElements.define('cart-sticky-bar', CartStickyBar);
}
